import OnlinePresence from '../components/PricingPageContent/OnlinePresence';
import GetStarted from '../components/GetStartedContent/GetStarted';
import Footer from '../components/Footer/Footer';

const GetStartedPage = function () {
  return (
    <>
      <GetStarted />
      <OnlinePresence />
      <Footer />
    </>
  );
};

export default GetStartedPage;
